// Edge Elite — Logo + Pelota animada
// Pack oficial de marca. Incluye:
//   - EELogo:   wordmark "Edge Elite" + punto naranja con costura de básquet
//   - EEBrand:  logo + tagline stacked (para el sidebar)
//   - HeroBall: pelota animada (para el "Hola, Matías" del dashboard)
//
// Color oficial: #FF4D0D. Tinta: #0A0A0C.
// Las animaciones de HeroBall viven en index.css (keyframes ee-ball-*).

import React from 'react';

// ── EELogo: wordmark + punto naranja ──────────────────────────
export const EELogo = ({ size = 22 }) => {
  const dot = size * 0.32;
  return (
    <div
      style={{
        fontFamily: '-apple-system, "SF Pro Display", "Inter", system-ui, sans-serif',
        fontSize: size,
        fontWeight: 700,
        letterSpacing: '-0.04em',
        lineHeight: 1,
        color: 'currentColor',
        display: 'inline-flex',
        alignItems: 'baseline',
        whiteSpace: 'nowrap',
      }}
    >
      Edge Elite
      <span
        aria-hidden="true"
        style={{
          display: 'inline-block',
          width: dot,
          height: dot,
          marginLeft: size * 0.1,
          position: 'relative',
          top: size * 0.02,
          flex: 'none',
        }}
      >
        <svg viewBox="0 0 24 24" width={dot} height={dot} fill="none">
          <circle cx="12" cy="12" r="12" fill="#FF4D0D" />
          <path
            d="M6 6c3.2 2.6 3.2 9.8 0 12"
            stroke="#0A0A0C"
            strokeOpacity="0.55"
            strokeWidth="1.6"
            strokeLinecap="round"
            fill="none"
          />
        </svg>
      </span>
    </div>
  );
};

// ── EEBrand: logo + tagline stacked (sidebar) ─────────────────
export const EEBrand = ({ size = 22 }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 4, minWidth: 0, flex: 1 }}>
    <EELogo size={size} />
    {/* Tagline: className ee-brand-tagline para que el override dark de
        index.css pueda subir intensidad sin pelear con un inline color. */}
    <div className="ee-brand-tagline">
      Hecho para ganar con ventaja real
    </div>
  </div>
);

// ── HeroBall: pelota de básquet animada ───────────────────────
// Animaciones: idle spin + bob, hover rápido, click pop. Keyframes en index.css.
export const HeroBall = ({ size = 32 }) => (
  <span
    aria-hidden="true"
    className="ee-hero-ball"
    style={{
      width: size,
      height: size,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      flex: 'none',
    }}
  >
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      fill="none"
      className="ee-hero-ball-svg"
    >
      <circle cx="32" cy="32" r="30" fill="#FF4D0D" />
      <path
        d="M2 32h60 M32 2v60 M10 10c10 8 10 36 0 44 M54 10c-10 8-10 36 0 44"
        stroke="#0A0A0C"
        strokeOpacity="0.9"
        strokeWidth="1.8"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  </span>
);
